import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import AccountForm from '../containers/AccountFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class AccountAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `AccountAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('account_route_add')} />
          <AccountForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default AccountAddScreen;

Logger.log('silly', `AccountAddScreen loaded.`);
